import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import * as Swiper from 'swiper/dist/js/swiper.js';
import '../../interfaces/slider.interface';
import './how-to-guide-v3.component.scss';
var HowToGuideV3 = /** @class */ (function (_super) {
    tslib_1.__extends(HowToGuideV3, _super);
    function HowToGuideV3(element) {
        return _super.call(this, element) || this;
    }
    HowToGuideV3.prototype.init = function () {
        var _this = this;
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.createSlider();
        window.addEventListener('resize', function () {
            _this.sliderComponent.destroy();
            _this.createSlider();
        });
    };
    HowToGuideV3.prototype.bindEvents = function () {
    };
    HowToGuideV3.prototype.createSlider = function () {
        var windowWidth = document.body.clientWidth;
        if (windowWidth > 767) {
            this.sliderConfig = {
                effect: 'fade',
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                initialSlide: 0,
                breakpoints: {
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                        centeredSlides: true,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                        centeredSlides: true,
                    }
                },
                freeMode: false,
                navigation: {
                    nextEl: '.how-to-guide-v3__container--wrapper__controls--inner__next--button',
                    prevEl: '.how-to-guide-v3__container--wrapper__controls--inner__prev--button',
                }
            };
        }
        else {
            this.sliderConfig = {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                initialSlide: 0,
                breakpoints: {
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                        centeredSlides: true,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                        centeredSlides: true,
                    }
                },
                freeMode: false,
                navigation: {
                    nextEl: '.how-to-guide-v3__container--wrapper__controls--inner__next--button',
                    prevEl: '.how-to-guide-v3__container--wrapper__controls--inner__prev--button',
                }
            };
        }
        this.sliderComponent = new Swiper(this.sliderContainer, this.sliderConfig);
    };
    return HowToGuideV3;
}(Base));
export { HowToGuideV3 };



//////////////////
// WEBPACK FOOTER
// ./components/how-to-guide-v3/how-to-guide-v3.component.ts
// module id = 696
// module chunks = 0